import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMap } from "react-map-gl";
import { useKey } from "../../../Map/components/MapEventHandler/useKey";
import { Tooltip, Popconfirm } from "antd";

import { siftActions, inputsActions } from "../../../Redux";

import { boundary_poly, exclusion_poly, inactive_poly, offeset_poly, protractor, measure_dims, delete_single_polygon } from "../../../../assets/images";

const PolygonTools = ({ id }) => {
  const dispatch = useDispatch();

  const { current: mapRef } = useMap();
  const map = mapRef.getMap();

  // Handle both single ID and array of IDs
  const isMultiSelect = Array.isArray(id);
  const site_features = useSelector((state) => state.inputs.site_features);
  const selected_feature = !isMultiSelect ? site_features[id] : null;
  const selected_features = isMultiSelect ? id.map((featureId) => site_features[featureId]).filter(Boolean) : [];
  const selectedFeatureId = useSelector((state) => state.inputs.selectedFeatureId);

  const show_offset_tool = useSelector((state) => state.sift.ioManager.uiState.show_offset_tool);

  const show_azi = useSelector((state) => state.inputs.uiState.show_azi);
  const show_dims = useSelector((state) => state.inputs.uiState.show_dims);

  //hot key stuff
  const boundary_hotkey = useKey("b");
  const exclusion_hotkey = useKey("e");
  const inactive_hotkey = useKey("i");

  const mapHasFocus = () => {
    return document.getElementById("MapboxMap") == document.activeElement;
  };

  useEffect(() => {
    if (!mapHasFocus()) return;
    if (!selected_feature) return;
    if (selected_feature?.geometry?.type == "LineString") return;
    if (boundary_hotkey) {
      updateIdentity(1);
    }
    if (exclusion_hotkey) {
      updateIdentity(2);
    }
    if (inactive_hotkey) {
      updateIdentity(0);
    }
  }, [boundary_hotkey, exclusion_hotkey, inactive_hotkey]);

  const updateIdentity = (identity) => {
    if (isMultiSelect) {
      // Bulk update all selected features in one action
      dispatch(
        inputsActions.update_site_input("bulk_update_identity", {
          featureIds: id,
          identity: identity,
        }),
      );
    } else if (selected_feature) {
      // Create a copy to avoid mutating Redux state
      const updatedFeature = { ...selected_feature };
      updatedFeature.properties = { ...selected_feature.properties };
      updatedFeature.properties.identity = identity;

      if (identity == 0) updatedFeature.properties.active = !updatedFeature.properties.active;
      else updatedFeature.properties.active = true;

      dispatch(inputsActions.update_site_input("edit_site_feature", updatedFeature));
    }
  };

  const handleToggleDims = () => {
    let checked = !show_dims;
    dispatch(inputsActions.update_ui_state("show_dims", checked));
    // if (show_azi) dispatch(inputsActions.update_ui_state("show_azi", false));
  };

  const handleToggleAzi = () => {
    let checked = !show_azi;
    dispatch(inputsActions.update_ui_state("show_azi", checked));
    // if (show_dims) dispatch(inputsActions.update_ui_state("show_dims", false));
  };

  const delete_single_feature = () => {
    if (isMultiSelect) {
      // Bulk delete all selected features in one action
      dispatch(inputsActions.update_site_input("bulk_remove_features", id));
    } else {
      dispatch(inputsActions.update_site_input("remove_site_feature", id));
    }
  };

  const toggle_offset_polygon = () => {
    dispatch(siftActions.updateUIState("show_offset_tool", !show_offset_tool));
  };

  return (
    <section className="map-action-buttons" style={{ marginLeft: 5 }}>
      {((selected_feature && selected_feature.geometry.type == "Polygon") || (isMultiSelect && selected_features.length > 0)) && (
        <>
          <Tooltip placement="bottom" title="Offset Polygon" mouseEnterDelay={0.25} disabled={isMultiSelect}>
            <button onClick={() => toggle_offset_polygon()}>
              <img draggable={false} src={offeset_poly} />
            </button>
          </Tooltip>

          {/* <Tooltip placement="bottom" title="Show Polygon Azimuth" mouseEnterDelay={0.25}>
            <button className={show_azi ? "button-active" : ""} disabled={false} onClick={() => handleToggleAzi()}>
              <img draggable={false} src={protractor} />
            </button>
          </Tooltip>
          <Tooltip placement="bottom" title="Show Polygon Dimensions" mouseEnterDelay={0.25}>
            <button className={show_dims ? "button-active" : ""} disabled={false} onClick={() => handleToggleDims()}>
              <img draggable={false} src={measure_dims} />
            </button>
          </Tooltip> */}
          {/* <button onClick={() => console.log("delete me!")}>
        <img src={delete_polygon} />
      </button> */}
          {/* <section className="vert-line"></section> */}
          <Tooltip placement="bottom" title="Set As Boundary" mouseEnterDelay={0.25}>
            <button className="identity-button" onClick={() => updateIdentity(1)}>
              <img draggable={false} src={boundary_poly} />
            </button>
          </Tooltip>
          <Tooltip placement="bottom" title="Set As Exclusion" mouseEnterDelay={0.25}>
            <button className="identity-button" onClick={() => updateIdentity(2)}>
              <img draggable={false} src={exclusion_poly} />
            </button>
          </Tooltip>
          <Tooltip placement="bottom" title="Set as Inactive" mouseEnterDelay={0.25}>
            <button className="identity-button" onClick={() => updateIdentity(0)}>
              <img draggable={false} src={inactive_poly} />
            </button>
          </Tooltip>
          <Tooltip placement="bottom" title={isMultiSelect ? `Delete ${selected_features.length} Polygons` : "Delete Selected Polygon"} mouseEnterDelay={0.25}>
            <Popconfirm
              placement="bottom"
              title={isMultiSelect ? `Delete ${selected_features.length} polygons?` : `Are you sure?`}
              onCancel={() => console.log("canceled")}
              okText="Yes"
              cancelText="No"
              onConfirm={() => delete_single_feature()}
            >
              <button>
                <img draggable={false} src={delete_single_polygon} />
              </button>
            </Popconfirm>
          </Tooltip>
        </>
      )}

      {/* {selectedFeatureId &&selected_feature && selected_feature.geometry.type == "Polygon" ? (
       ---> THE STUFF ABOVE USED TO BE HERE BUT IM NOT SURE IF IT'S NEEDED ANYMORE SO I'M LEAVING IT -- JOSH
      ) : (
        <>
          <Tooltip placement="bottom" title="Delete Selected Polygon" mouseEnterDelay={0.25}>
            <Popconfirm placement="bottom" title={`Are you sure?`} onCancel={() => console.log("canceled")} okText="Yes" cancelText="No" onConfirm={() => delete_single_feature()}>
              <button>
                <img draggable={false} src={delete_single_polygon} />
              </button>
            </Popconfirm>
          </Tooltip>
        </>
      )} */}
    </section>
  );
};

export { PolygonTools };
